import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/TopicTypeService";
const store = {};
const mutations = {
    SET_TTY_SIMPLE_LIST(state, posts) {
        state.ttySimpleList = posts;
        state.ttySimpleListIsLoading = false;
    },
    SET_TTY_CANCREATE_LIST(state, posts) {
        state.ttyCanCreateList = posts;
        state.ttyCanCreateListIsLoading = false;
    },
    SET_ALLOWED_TOPICTYPE_ROUND_LIST(state, posts) {
        state.allowedTopicTypeRoundList = posts.data;
        state.allowedTopicTypeRoundListIsLoading = false;
        state.selectedTtrId = posts.selectedTtrId;
    },
    GET_DETAIL(state, posts) {
        if (posts.success == true) {
            state.topicTypeDetail = posts.data;
            state.topicTypeDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    GET_TOPICTYPE_GROUP_LIST(state, posts) {
        if (posts.success == true) {
            state.topicTypeGroupList = posts.data;
            state.topicTypeGroupListChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SAVE_TOPICTYPE_GROUP_LIST(state, posts) {
        if (posts.success == true) {
            state.topicTypeGroupListChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SAVE_TOPICTYPE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.topicTypeDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
};
const state = {
    ttySimpleListIsLoading: false,
    ttySimpleList: [],
    ttyCanCreateListIsLoading: false,
    ttyCanCreateList: [],
    allowedTopicTypeRoundListIsLoading: false,
    allowedTopicTypeRoundList: [],
    selectedTtrId: null,
    topicTypeDetail: {},
    topicTypeDetailChanged: false,
    topicTypeGroupList: [],
    topicTypeGroupListChanged: false,
};
const getters = {};
const actions = {
    getTtySimpleList({ commit }) {
        state.ttySimpleListIsLoading = true;
        axios
            .get(baseUri + '/GetSimpleList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_TTY_SIMPLE_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getTtyCanCreateList({ commit }) {
        state.ttyCanCreateListIsLoading = true;
        axios
            .get(baseUri + '/GetCanCreateList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_TTY_CANCREATE_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getAllowedTopicTypeRoundList({ commit }) {
        state.allowedTopicTypeRoundListIsLoading = true;
        axios
            .get(baseUri + '/GetAllowedTopicTypeRoundList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_ALLOWED_TOPICTYPE_ROUND_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveSelectedTtrId({ commit }, data) {
        if (this.selectedTtrId && this.selectedTtrId != data.ttrId) {
            var formData = new FormData();
            formData.append("ttrId", data.ttrId);
            axios
                .post(baseUri + '/SaveSelectedTtrId', formData)
                .then(res => {
                    if (res.data.success == true) {
                        console.log(commit);
                    }
                    else {
                        alert(res.data.errorMessage);
                    }
                });
        }
    },
    getTopicTypeDetail({ commit }, data) { 
        var formData = new FormData();
        formData.append("ttyId", data.ttyId);
        axios
            .post(baseUri + '/GetDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getTopicTypeGroupList({ commit }, data) {
        var formData = new FormData();
        formData.append("ttyId", data.ttyId);
        axios
            .post(baseUri + '/GetTopicTypeGroupList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_TOPICTYPE_GROUP_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveTopicTypeDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.topicTypeDetail));
        axios
            .post(baseUri + '/SaveDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_TOPICTYPE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }

            });
    },
    saveTopicTypeGroupList({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.topicTypeGroupList));
        formData.append("ttyId", state.topicTypeDetail.TtyId);
        axios
            .post(baseUri + '/SaveTopicTypeGroupList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_TOPICTYPE_GROUP_LIST', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}